// components/schema/InfoSection.jsx

import React, { useState } from "react"
import { Info, ExternalLink } from "lucide-react"

export default function InfoSection() {
  const [showInfo, setShowInfo] = useState(false)

  return (
    <div className="mt-4 text-xs text-gray-600 dark:text-gray-300 relative">
      <div className="flex items-center gap-2">
        <span>
          Tip: type{" "}
          <code className="px-1 rounded bg-gray-100 dark:bg-gray-800">
            CREATE NODE TYPE
          </code>{" "}
          or use the autocomplete snippets.
        </span>
        <button
          type="button"
          onClick={() => setShowInfo(v => !v)}
          aria-expanded={showInfo}
          aria-controls="pgs-info-popover"
          className="inline-flex items-center gap-1 px-2 py-1 rounded-md border border-gray-300 dark:border-gray-700
                    bg-white hover:bg-gray-50 dark:bg-gray-800 dark:hover:bg-gray-700"
          title="Related papers & grammar"
        >
          <Info className="h-4 w-4" />
        </button>
      </div>

      {showInfo && (
        <div
          id="pgs-info-popover"
          className="mt-2 w-full sm:w-[520px] rounded-md border border-gray-200 dark:border-gray-700
                    bg-white dark:bg-gray-800 shadow-lg p-3"
        >
          <div className="text-[13px] leading-5">
            <div className="font-semibold mb-2">Related resources</div>
            <ul className="space-y-1">
              <li className="flex items-start gap-2">
                <span className="mt-0.5">•</span>
                <a
                  href="https://dl.acm.org/doi/pdf/10.1145/3589778"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1 text-blue-700 dark:text-blue-300 hover:underline"
                >
                  PG-Schema Paper
                  <ExternalLink className="h-3.5 w-3.5" />
                </a>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-0.5">•</span>
                <a
                  href="https://dl.acm.org/doi/pdf/10.1145/3448016.3457561"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1 text-blue-700 dark:text-blue-300 hover:underline"
                >
                  PG-Keys Paper
                  <ExternalLink className="h-3.5 w-3.5" />
                </a>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-0.5">•</span>
                <a
                  href="https://github.com/domel/pgschema"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1 text-blue-700 dark:text-blue-300 hover:underline"
                >
                  PG-Schema Grammar Repository
                  <ExternalLink className="h-3.5 w-3.5" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      )}
    </div>
  )
}
